import Component from '../../../shared/component';

export default class ConversationsSwitcher extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    this.$selectElement = this.$element.find('.conversationsSwitcher-select');

    this.bindEvents();
  }

  bindEvents() {
    this.handleChange = this.handleChange.bind(this);

    this.$selectElement.on('change.ConversationsSwitcher', this.handleChange);
  }

  unbindEvents() {
    this.$selectElement.off('change.ConversationsSwitcher', this.handleChange);
  }

  handleChange() {
    const $selectedOption = this.$element.find(':selected');

    window.Turbolinks.visit($selectedOption.data('url'));
  }
}
